import React, { useEffect, useState, useRef } from 'react';
import { Typography, Paper } from '@material-ui/core';
import { connect } from "react-redux";
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import { DialogContent, DialogActions } from '../Dialog/Dialog';
import { getAllDrivers } from "../../../store/actions/vehicleActionCreator";
import {
    TextField,
    Checkboxes,
    Radios,
    Select,
    DatePicker,
    TimePicker,
    Autocomplete
} from 'mui-rff';
import { createFilterOptions } from '@material-ui/lab/Autocomplete';
import CircularProgress from '@material-ui/core/CircularProgress';
import parse from 'autosuggest-highlight/parse';
import match from 'autosuggest-highlight/match';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import { AddPersonIcon } from '../../../components/icons';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { Form } from 'react-final-form';
import { logoutUser } from "../../../store/actions/authActionCreators";
import { withRouter, useHistory } from 'react-router-dom';
import useStyles from '../../pages/css/forms';
import DriverGaveAndGot from '../DriverDialogs/DriverGaveAndGot';
import AddDialog from '../AddDialogComponent/AddDialogComponent';
import { DialogTitle, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

function sleep(delay = 0) {
    return new Promise((resolve) => {
        setTimeout(resolve, delay);
    });
}

const filter = createFilterOptions();

const DriverNameSelect = ({ props, defaultName, driverDetail, dispatchGetAllDrivers, onConfirm, onOpen, onClose, onSave, vehicle, dispatchAddNewDriver, type, fromSingleTruck }) => {

    // const { user, dispatchAddNewParty, ...other } = props;

    const [dialogopen, setDialogOpen] = React.useState(onOpen);
    const [open, setOpen] = React.useState(false);
    const [addDriverOpen, toggleAddDriverOpen] = React.useState(false);
    const [driverValue, setDriverValue] = React.useState(null);
    const [options, setOptions] = React.useState([]);
    const [driverBalance, setDriverBalance] = useState(false);
    const [addDriverDialog, setAddDriverDialog] = useState(false);

    const loading = open && options.length === 0;

    const classes = useStyles();
    // const { register, handleSubmit, control, errors } = useForm({
    //     mode: 'onChange',
    //     reValidateMode: 'onChange',
    //     defaultValues: {
    //         name: defaultName ? defaultName : '',
    //     },

    // });

    useEffect(() => {
        setDriverValue(driverDetail);
    }, [driverDetail])

    const initialValues = {
        driver: driverValue
    }

    useEffect(() => {
        setOptions(vehicle && vehicle.drivers ? vehicle.drivers : []);
        setDriverValue(driverDetail);
    }, [vehicle.drivers]);

    useEffect(() => {
        if(open){
            dispatchGetAllDrivers(
                null,
                (data) => {
                    // if (data && data.status && data.status.code == 200) {
                    //     setDialogOpen(true);
                    // }
                },
                () => {
                }
            );
        }
        
    }, [open]);

    // React.useEffect(() => {
    //     let active = true;

    //     if (loading) {
    //         (async () => {
    //             const response = await dispatchGetAllDrivers(
    //                 null,
    //                 () => {
    //                 },
    //                 () => {
    //                 }
    //             );
    //             await sleep(1e3); // For demo purposes.
    //             //const parties = await response.json();

    //             if (active) {
    //                 setOptions(vehicle && vehicle.drivers ? vehicle.drivers : []);
    //             }
    //         })();

    //         return () => {
    //             active = false;
    //         };
    //     }
    //     return undefined;
    // }, [loading]);

    const validate = values => {


        const errors = {};

        if (!values.driver) {
            errors.driver = 'Please Select a Driver';
        }

        return errors;
    };

    const handleClose = (status) => {
        onClose(false);
    };

    const onSubmit = values => {
        setDialogOpen(false);
        if (fromSingleTruck && driverValue && driverValue.id) {
            onConfirm(driverValue.id);
        } else {
            setDriverBalance(true);
        }
    }

    const handleAddDriver = () => {
        setAddDriverDialog(true);
        setDialogOpen(false);
    }

    const driverDetails = [
        {
            size: 6,
            visible: options.length > 0,
            field: (
                <Autocomplete
                    classes={{
                        listbox: classes.listBoxAutoCompelete,
                        option: classes.listBoxOption
                    }
                    }
                    className={classes.mtV2}
                    id="select-driver-list"
                    //label="Party"
                    name="driver"
                    size="small"
                    //placeholder="Select a Party"
                    //open={open}
                    value={driverValue}
                    onOpen={() => {
                        setOpen(true);
                    }}
                    onClose={() => {
                        setOpen(false);
                    }}
                    onChange={(event, newValue) => {
                        if (typeof newValue === 'string') {

                            // timeout to avoid instant validation of the dialog's form.
                            setTimeout(() => {
                                toggleAddDriverOpen(true);
                                // setPartyDialogValue({
                                //     name: typeof Number(newValue) != 'number' ? newValue : "",
                                //     number: typeof Number(newValue) == 'number' ? newValue : "",
                                // });
                            });
                        } else if (newValue && newValue.inputValue) {
                            toggleAddDriverOpen(true);
                            // setPartyDialogValue({
                            //     name: typeof Number(newValue.inputValue) != 'number' ? newValue.inputValue : "",
                            //     number: typeof Number(newValue.inputValue) == 'number' ? newValue.inputValue : "",
                            // });
                        } else if (newValue && newValue.inputValue === '') {
                            toggleAddDriverOpen(true);
                            // setPartyDialogValue({
                            //     name: typeof Number(newValue.inputValue) != 'number' ? newValue.inputValue : "",
                            //     number: typeof Number(newValue.inputValue) == 'number' ? newValue.inputValue : "",
                            // });
                        } else {
                            setDriverValue(newValue);
                        }
                    }}
                    getOptionSelected={(option, value) => option.id === value.id}
                    required={true}
                    autoHighlight
                    freeSolo
                    options={options ? options : []}
                    selectOnFocus
                    clearOnBlur
                    handleHomeEndKeys
                    getOptionValue={option => option.id}
                    //getOptionLabel={option => option.name}
                    getOptionLabel={(option) => {
                        // e.g value selected with enter, right from the input
                        if (typeof option === 'string') {
                            return option;
                        }
                        if (option.inputValue) {
                            return option.inputValue;
                        }
                        return option && option.name ? option.name : ""
                    }}
                    disableCloseOnSelect={false}
                    filterOptions={(options, params) => {

                        const filtered = filter(options, params);

                        filtered.unshift({
                            inputValue: params.inputValue,
                            name: params.inputValue && params.inputValue.length > 1 ? `Add Details for  "${params.inputValue}"` : `Add New Driver`,
                        });
                        /*if (params.inputValue !== '') {
                          filtered.push({
                            inputValue: params.inputValue,
                            name: `Add Details for"${params.inputValue}"`,
                          });
                        }*/

                        return filtered;
                    }}
                    renderOption={(option, { selected, inputValue }) => {
                        let matchesName, matchesNumber;
                        let partsName, partsNumber;

                        matchesName = match(option.name, inputValue);
                        partsName = parse(option.name, matchesName);
                        matchesNumber = match(option.contactNumber, inputValue);
                        partsNumber = parse(option.contactNumber, matchesNumber);

                        if (option && option.id) {
                            return (
                                <div className={classes.partyListItem}>
                                    {partsName.map((part, index) => {
                                        return (<span key={index} style={{ fontWeight: part.highlight ? 700 : 300, color: part.highlight ? '#00875a' : '#0b1323' }}>
                                            {part.text}
                                        </span>
                                        )
                                    })}
                                    {option.contactNumber && <>
                                        <FiberManualRecordIcon className={classes.titleBullet}></FiberManualRecordIcon>
                                        {partsNumber.map((part, index) => {
                                            return (<span key={index} style={{ fontWeight: part.highlight ? 700 : 300, color: part.highlight ? '#00875a' : '#0b1323' }}>
                                                {part.text}
                                            </span>
                                            )
                                        })}
                                    </>}
                                </div>
                            );

                        } else {
                            return (
                                <div className={classes.partyAddListItem} onClick={() => handleAddDriver()}>
                                    <AddPersonIcon className={classes.addPersonIcon} />
                                    {partsName.map((part, index) => {
                                        return (<span key={index} style={{ fontWeight: 300, color: '#fff' }}>
                                            {part.text}
                                        </span>
                                        )
                                    })}
                                    <ChevronRightIcon className={classes.cherveRightIcon} />
                                </div>
                            );
                        }

                    }}
                    // renderInput={(params) => (
                    //     <TextField
                    //         {...params}
                    //         // label="Select a Driver"
                    //         placeholder="Select a Driver"
                    //         variant="outlined"
                    //         name="driver"
                    //         margin='normal'
                    //         InputProps={{
                    //             ...params.InputProps,
                    //             endAdornment: (
                    //                 <React.Fragment>
                    //                     {loading ? <CircularProgress color="inherit" size={20} /> : null}
                    //                     {params.InputProps.endAdornment}
                    //                 </React.Fragment>
                    //             ),
                    //         }}
                    //     />
                    // )}
                    textFieldProps={
                        {
                            placeholder: "Select a Driver",
                            variant: "outlined",
                            margin: 'none',
                        }
                    }
                    multiple={false}
                />
            ),
        }
    ]

    // const handleContinue = () => {
    //     setDriverBalance(true);
    //     onClose(false);
    //     setDialogOpen(false);
    // }

    const handleBalanceClose = () => {
        setDriverBalance(false);
        onClose(false);
    }

    const handleAddDriverModalClose = () => {
        setAddDriverDialog(false);
        onClose(false);
    }

    const handleOnConfirm = (driverIdValue) => {
        if (fromSingleTruck) {
            setAddDriverDialog(false);
            onConfirm(driverIdValue);
        } else {
            setAddDriverDialog(false);
            onClose(false);
        }
    }


    return (
        <>
            <div>
                <Dialog fullWidth={true}
                    maxWidth='xs'
                    onClose={handleClose} disableEscapeKeyDown={true} disableBackdropClick={true} aria-labelledby="add-driver-dialog-title" open={dialogopen}>
                    <DialogTitle className={classes.dialogTitleV2}>
                        <div className={classes.fw300}>Choose Driver</div>
                        <IconButton aria-label="close" className={classes.closeButton} onClick={handleClose}>
                            <CloseIcon />
                        </IconButton>
                    </DialogTitle>
                    <DialogContent dividers>
                        <Form
                            onSubmit={onSubmit}
                            initialValues={initialValues}
                            validate={validate}
                            render={({ handleSubmit, form, submitting, pristine, values }) => (
                                <form onSubmit={(event) => {
                                    const promise = handleSubmit(event);
                                    // promise && promise.then(() => {
                                    //     form.reset();
                                    // })
                                    return promise;
                                }} noValidate>
                                    <div className={classes.driverName} >Driver Name*</div>
                                    {driverDetails.map((item, idx) => (
                                        item.field
                                    ))}
                                    <div>
                                        <Button className={classes.continue} variant="outlined" type="submit">
                                            Continue
                                        </Button>
                                    </div>
                                </form>
                            )}
                        />
                    </DialogContent>
                </Dialog>
            </div>

            {addDriverDialog && <AddDialog open={addDriverDialog} onClose={handleAddDriverModalClose} type={'driver'} onConfirm={handleOnConfirm} fromDriver={true} fromDriverNameSelect={true} balanceType={type} fromSingleTruckComponent={fromSingleTruck} />}
            {driverBalance && <DriverGaveAndGot balanceType={type} onClose={handleBalanceClose} onOpen={driverBalance} driverId={driverValue && driverValue.id ? driverValue.id : ""} fromDriverListing={true} />}
        </>
    )
}

const mapStateToProps = (state) => ({ vehicle: state.vehicle });
const mapDispatchToProps = (dispatch) => ({
    dispatchLogoutAction: () => dispatch(logoutUser()),
    dispatchGetAllDrivers: (onSuccess, onFailure) => dispatch(getAllDrivers(null, onSuccess, onFailure)),
});
const DriverNameSelectWithRouter = withRouter(DriverNameSelect);
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DriverNameSelectWithRouter);